import React from "react"

import { AlertWidget } from "./alert/AlertWidget"
import { ChartWidget } from "./chart/ChartWidget"
import { FeedWidget } from "./feed/FeedWidget"
import { KpiWidget } from "./kpi/KpiWidget"
import { ListWidget } from "./list/ListWidget"
import { MapWidget } from "./map/MapWidget"
import { ProgressWidget } from "./progress/ProgressWidget"
import { RestrictedWidget } from "./restricted/RestrictedWidget"
import { SnapshotWidget } from "./snapshot/SnapshotWidget"
import { StubWidget } from "./stubs/StubWidget"
import { TableWidget } from "./table/TableWidget"
import type { WidgetProps } from "./types"

export const WidgetRenderer = (props: WidgetProps) => {
  // Read off the payload rather than `state` so every call site is covered by
  // construction — a restricted widget carries no data any renderer could show.
  if (props.payload?.no_access || props.state === "restricted")
    return <RestrictedWidget {...props} />

  switch (props.widget.type) {
    case "kpi":
      return <KpiWidget {...props} />
    case "chart":
      return <ChartWidget {...props} />
    case "feed":
      return <FeedWidget {...props} />
    case "progress":
      return <ProgressWidget {...props} />
    case "alert":
      return <AlertWidget {...props} />
    case "table":
      return <TableWidget {...props} />
    case "list":
      return <ListWidget {...props} />
    case "snapshot":
      return <SnapshotWidget {...props} />
    case "map":
      return <MapWidget {...props} />
    case "timeline":
    case "calendar":
    case "leaderboard":
      return <StubWidget {...props} />
    default:
      return <StubWidget {...props} />
  }
}
